import React from 'react';
import style from "./Carta.module.css";

const CarritoPanel = ({ 
  productosSeleccionados,
  onEliminarProducto,
  onActualizarCantidad,
  onRealizarPedido,
  onToggleCarrito,
  carritoVisible,
  isMobile
}) => {
  return (
    <div className={`${style.right_panel} ${isMobile && carritoVisible ? style.visible : ''}`}>
      <div className={style.carrito_container}>
        <h3 className={style.carrito_title}>
          Productos Seleccionados
          <button className={style.carrito_close_btn} onClick={onToggleCarrito}>×</button>
        </h3>
        <div className={style.carrito_content}>
          {productosSeleccionados.length === 0 ? (
            <p className={style.carrito_empty}>
              Haz clic en un producto para añadirlo a tu pedido
            </p>
          ) : (
            <div className={style.carrito_items}>
              {productosSeleccionados.map((producto, index) => (
                <div key={index} className={style.carrito_item}>
                  <div className={style.carrito_item_info}>
                    <div className={style.carrito_item_header}>
                      <h4 className={style.carrito_item_nombre}>
                        {producto.nombre} 
                      </h4>
                      <p className={style.carrito_item_unidades}>
                        {producto.cantidad || 1} unidades
                      </p>
                    </div>
                    
                    <div className={style.carrito_item_actions}>
                      <div className={style.cantidad_controles}>
                        <button 
                          className={style.boton_cantidad}
                          onClick={(e) => {
                            e.stopPropagation();
                            onActualizarCantidad(index, (producto.cantidad || 1) - 1);
                          }}
                        >
                          -
                        </button>
                        <span className={style.cantidad_valor}>{producto.cantidad || 1}</span>
                        <button 
                          className={style.boton_cantidad}
                          onClick={(e) => {
                            e.stopPropagation();
                            onActualizarCantidad(index, (producto.cantidad || 1) + 1);
                          }}
                        >
                          +
                        </button>
                      </div>
                      <button 
                        className={style.boton_eliminar}
                        onClick={(e) => {
                          e.stopPropagation();
                          onEliminarProducto(index);
                        }}
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              
              <div className={style.carrito_total}>
                <h4>Total de productos</h4>
                <p>{productosSeleccionados.reduce((total, producto) => total + (producto.cantidad || 1), 0)} unidades</p>
              </div>
            </div>
          )}
        </div>
        
        <button 
          className={style.boton_realizar_pedido}
          onClick={onRealizarPedido}
          disabled={productosSeleccionados.length === 0}
        >
          Compartir Pedido
        </button>
      </div>
    </div>
  );
};

export default CarritoPanel;